<template>
	<div class="view">
		<ArticleContainer>
			<header class="section">
				<div class="left">
					<div class="title">Тренды в индустрии</div>
					<div
						class="text light"
					>Есть ощущение, что сейчас татуировка переживает свой золотой век. В России, конечно, он начался позже, чем в той же Америке. Там почти на каждом телеканале, включая даже какие-то мелкие городские каналы, есть свое тату-шоу.
						<div class="line"></div>
					</div>
				</div>
				<div class="right"></div>
			</header>

			<div class="section one">
				<div class="inner">
					<div class="right">
						<div class="subtitle">О популярности татуировки</div>
						<div
							class="text light"
						>Свою первую татуировку я сделал в двадцать четыре года. На руке у меня был набит биомеханический червь с женским лицом, а на бицепсе — браслет из колючек. Это были двухтысячные. В то же время я учился делать татуировки и на курсах познакомился с парнем, который уехал из России на Кипр, но потом вернулся сюда за каким-то сертификатом. В общем, мы ушли с этих занятий, поехали к нему домой, и он мне подсунул на выбор две картинки. Одну из них он мне и набабахал. Утром я, конечно, офигел. А чуть позже с горем пополам сам себе перебил эту татуировку в того самого червя.</div>
					</div>
					<div class="left">
						<img src="@/assets/article3/2.jpg">
					</div>
				</div>
			</div>

			<div class="section two">
				<div class="inner">
					<div class="subtitle">О трендах</div>
					<div
						class="text light"
					>Еще десять лет назад моим среднестатистическим клиентом был мужичок за сорок с золотой цепочкой и на хорошей машине. Причем не бандит, просто состоятельный — тысячу СМС пришлет, что в пробке торчит. А сейчас очень разная публика: и рэперы, и полицейские, и банковские служащие, и бухгалтера. Клиенты сильно изменились. Отличаются только стили. Если какие-нибудь байкеры выбирают традиционные черепа и прочее, то банкиры, например, останавливаются на чем-то более спокойном — им подавай вензеля, орнаменты, мандалы, какие-то буддистские штуки. Молодые ребята хотят модные вещи: тонкие контуры, графику. Раньше еще на сто человек минимум двое приходили добивать или перекрывать тюремные татуировки. Сейчас таких нет. Как вымерли.</div>
					<div class="bottom">
						<div class="left">
							<div class="subtitle">О терпении</div>
							<div
								class="text light"
							>Если вы хотите забить себе спину, то вам нужно в характере иметь невероятное постоянство. Или будьте готовы к тому, что будете ходить ко мне десять лет. Люди в большинстве своем спонтанные. И ленивые. Очень многие начинают делать татуировку на спине и бросают через пару сеансов. И находят много причин — нет времени, сменился образ жизни. Если вы встретите человека с законченной работой на спине, знайте — на него можно положиться.</div>
						</div>
						<div class="right">
							<img src="@/assets/article3/3.jpg">
						</div>
					</div>
				</div>
			</div>

			<div class="section three"></div>

			<div class="section four">
				<div class="inner">
					<div class="left">
						<img src="@/assets/article3/5.jpg">
					</div>
					<div class="right">
						<div class="subtitle">О мужской и женской боли</div>
						<div
							class="text light"
						>Первая татуировка — это всегда волнительно: некоторые падают в обморок, не успев еще ни одного укола получить. Я заметил, что чаще всего боятся боли именно здоровые брутальные мужики — всякие борцы, качки. А дрищи вроде меня спокойно сидят по пять-шесть часов. Некоторые засыпают. Когда человек перенервничал, у него происходит впрыск адреналина, а потом он понимает, что не все так страшно, расслабляется и отъезжает. Девушки же намного легче переносят боль, чем молодые люди. Часто бывает, что я работаю с девушкой, а вокруг мужики постанывают и попискивают. Хотя, конечно, если колешь на ребрах или на груди, это действительно жутко больно. На шее еще неприятно.</div>
					</div>
				</div>
			</div>

			<div class="section five">
				<div class="inner">
					<div class="subtitle">О ценах на татуировки</div>
					<div
						class="text light"
					>Моя работа стоит 9000 рублей за час. Это средняя цена на рынке, золотая середина. В Америке я брал сначала 150 долларов в час, потом — 200. Есть, конечно, у нас ребята, которые берут и по 15 000 рублей. А есть и те, кто целый день возится за 5000. Возникает вопрос к качеству работы мастера, который во столько оценивает свою работу. Человек, который давно занимается татуировкой и делает хорошо, стоит явно дороже.</div>

					<img src="@/assets/devider2.png">
					<img class="image" src="@/assets/article3/6.jpg">
				</div>
			</div>
		</ArticleContainer>
	</div>
</template>

<script>
import ArticleContainer from '@/components/ArticleContainer'

export default {
	components: {
		ArticleContainer
	},
}
</script>



<style lang="less" scoped>
@import "../styles.less";

.view {
	width: 100vw;
	height: 100vh;
	@media (max-width: 900px) {
		height: auto;
	}
}

.section {
	background: @color-main;
	color: #000;
}

.text {
	font-size: 16px;
	max-width: 500px;
	text-align: left;

	&.light {
		color: #fff;
	}

	&.dark {
		font-family: @font-title;
		font-size: 20px;
		font-weight: bold;
		line-height: 26px;
		text-transform: uppercase;
	}

	&.dark.big {
		font-size: 30px;
		line-height: 36px;
		text-transform: none;
	}
}

.subtitle {
	font-size: 20px;
	margin-bottom: 15px;
	text-align: left;
	font-weight: bold;
}

header {
	/deep/ .fp-tableCell {
		display: flex;
	}

	.left {
		width: 55vw;
		height: 100vh;
		background: @color-main;
		color: #000;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.title {
			width: 100%;
			max-width: 500px;
			font-size: 60px;
			font-weight: bold;
			margin-bottom: 30px;
			text-transform: uppercase;
			font-family: @font-title;
			text-align: left;
		}

		.text {
			line-height: 30px;
			font-size: 18px;
		}

		.line {
			width: 2px;
			height: 50px;
			background: #fff;
			margin-top: 20px;
			transform-origin: top;
			animation: bounceAnim 1.2s linear infinite;
		}
	}

	.right {
		width: 45vw;
		height: 100vh;
		background-image: url("../assets/article3/1.jpg");
		background-size: cover;
		background-position: center top;
	}

	@keyframes bounceAnim {
		0%,
		100% {
			transform: scaleY(0.8);
		}
		50% {
			transform: scaleY(1);
		}
	}

	@media (max-width: 900px) {
		display: flex;
		flex-direction: column-reverse;

		.left {
			width: 100vw;
			max-width: 90%;
			height: auto;
			margin: 0 auto;

			.title {
				font-size: 30px;
				padding-top: 30px;
				margin-bottom: 20px;
			}

			.line {
				display: none;
			}
		}

		.right {
			width: 100vw;
			height: 60vh;
		}
	}
}

.qoute {
	.inner {
		width: 100%;
		max-width: 800px;
		margin: 0 auto;
	}
	.quote-text {
		text-align: center;
		font-size: 50px;
		font-family: @font-title;
		font-weight: bold;
		line-height: 48px;
		margin: 40px 0;
	}

	@media (max-width: 900px) {
		.inner {
			padding-top: 30px;
			padding-bottom: 30px;
		}

		.quote-text {
			width: 90%;
			margin: 30px auto;
			font-size: 36px;
			line-height: 40px;
		}
	}
}

.section.one {
	.inner {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.text {
		margin-bottom: 30px;
	}

	.right {
		max-width: 420px;
		margin-right: 60px;
		line-height: 26px;
	}

	@media (max-width: 900px) {
		.inner {
			flex-direction: column;
			width: 90%;
			margin: 0 auto;
		}

		.left {
			margin-bottom: 30px;
		}

		.right {
			margin: 0;
			margin-bottom: 30px;
			margin-top: 30px;

			img {
				width: 100%;
			}
		}
	}
}

.section.two {
	.inner {
		margin: 0 auto;
		max-width: 900px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.subtitle {
		width: 100%;
		text-align: left;
	}

	.text {
		max-width: 100%;
	}

	.bottom {
		display: flex;
		margin-top: 50px;

		.right {
			margin-left: 50px;
		}
	}

	@media (max-width: 900px) {
		.inner {
			flex-direction: column;
			width: 90%;
			margin: 0 auto;
			padding-top: 30px;
		}

		.bottom {
			flex-direction: column-reverse;
			margin: 30px 0;

			.right {
				margin: 0;
				margin-bottom: 30px;
				img {
					width: 100%;
				}
			}
		}
	}
}

.section.three {
	background-size: cover;
	background-image: url(../assets/article3/4.jpg);

	@media (max-width: 900px) {
		width: 100vw;
		height: 60vh;
		background-position: center;
	}
}

.section.four {
	.inner {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.text {
		margin-bottom: 30px;
	}

	.right {
		max-width: 360px;
		margin-left: 60px;
		line-height: 26px;
	}

	@media (max-width: 900px) {
		.inner {
			flex-direction: column;
			width: 90%;
			margin: 0 auto;
			padding-top: 30px;
		}

		.right {
			margin: 0;
			margin-bottom: 30px;
			margin-top: 30px;

			img {
				width: 100%;
			}
		}
	}
}

.section.five {
	.inner {
		margin: 0 auto;
		max-width: 780px;
	}

	.subtitle {
		width: 100%;
		text-align: center;
	}

	.text {
		max-width: 600px;
		margin: 0 auto;
		text-align: center;
	}

	.text.light {
		margin-bottom: 50px;
	}

	img {
		margin: 30px auto;
	}

	@media (max-width: 900px) {
		.inner {
			width: 90%;
			margin: 0px auto;
			padding: 30px 0;
			flex-direction: column;
		}

		img.image {
			width: 100%;
		}
	}
}
</style>
